// extracted by mini-css-extract-plugin
export var amount = "slider-module--amount--437d6";
export var arrow = "slider-module--arrow--b9711";
export var bigImg = "slider-module--bigImg--2ec14";
export var bottomSlider = "slider-module--bottomSlider--fb0b7";
export var bottomWrapper = "slider-module--bottomWrapper--bc56d";
export var fadeInAnimation = "slider-module--fadeInAnimation--f45a7";
export var figcaption = "slider-module--figcaption--86b01";
export var figure = "slider-module--figure--2e466";
export var navigation = "slider-module--navigation--35a9b";
export var next = "slider-module--next--01340";
export var prev = "slider-module--prev--ef8a5";
export var wrapper = "slider-module--wrapper--3c753";
export var zoomBtn = "slider-module--zoomBtn--39a12";